import React from 'react';
import parse from 'html-react-parser';

import { FaqTypes } from '../../types/faq';
import Accordion from '../Common/Accordion';

const Faqs: React.FunctionComponent<FaqTypes> = (props: FaqTypes) => {
  const { category, questions, categoryShouldBeOpen } = props;
  const [showQuestions] = React.useState(categoryShouldBeOpen);
  const faqRef = React.useRef<HTMLDivElement>(null);

  const scrollToQuestion = (): void => {
    if (faqRef.current) {
      faqRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  React.useEffect(() => {
    if (showQuestions && faqRef && faqRef.current) {
      scrollToQuestion();
    }
  }, [showQuestions]);

  const preppedQuestions = questions.map((question, key): React.JSX.Element => {
    return (
      <Accordion key={`${category}-${question.values.name}-${key}`} title={question.values.name}>
        <>{parse(question.values.body)}</>
      </Accordion>
    );
  });

  const faqCategory = <div>{preppedQuestions}</div>;

  return (
    <>
      <Accordion className="faq" open={showQuestions} title={category}>
        {faqCategory}
      </Accordion>
    </>
  );
};

export default Faqs;
